import { createSlice } from '@reduxjs/toolkit'

import { addVehicle } from '../../services/userServices'
import { RootState } from '../../store/store'

// State type for the Redux slice
interface UserState {
  loading: boolean
  error: string | undefined
}

// Initial state for the Redux slice
const initialState: UserState = {
  loading: false,
  error: undefined
}

// Create a Redux slice
export const addVehicleSlice = createSlice({
  name: 'addVehicle',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(addVehicle.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      addVehicle.fulfilled,
      (state) => {
        state.loading = false
        state.error = undefined
      }
    )
    builder.addCase(addVehicle.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

// Selectors
export const addVehicleSelector = (state: RootState): UserState => state.addVehicleReducer
export default addVehicleSlice.reducer
